import React from 'react';

import PropTypes from 'prop-types';

const TimeLabel = ({ time }) => {
    return (
        <div className="w-[4.375rem] px-2.5 py-[19px] text-right text-9 uppercase text-icoGray-500">
            {time}
        </div>
    );
};

TimeLabel.propTypes = {
    time: PropTypes.string.isRequired
};

export default TimeLabel;
